<template>
  <div class="contenedor">
    <!-- Ide: {{this.$route.params.ide}} | Pli: {{this.$route.params.pli}} | Step: {{this.$store.state.step}}
    IdStep: {{ parseInt(this.$store.state.idStep) }} | IdSiguienteStep: {{ regSteps[(parseInt(this.$store.state.step) + 1)].id }} -->
    <!-- <h2>{{$t('common.insc_title')}}:</h2> -->
    <h2>{{ this.$store.state.evento.Nombre }}</h2>
    <!-- <h4>{{$t('common.insc_plan_title')}}:</h4> -->
    <h3>{{ this.$store.state.evento.NombrePlan }}</h3>
    <small>{{ this.$store.state.evento.DetallesPlan }}</small>
    <small>{{ this.$store.state.evento.BreveInstruccionParaRegistro }}</small>
    <div v-if="!this.$store.state.evento.insc_cerrada" class="container">
      <div v-if="this.$store.state.evento.error == 1" class="container">
        {{ this.$store.state.evento.error_msg }}
      </div>
      <div v-else>
        <template
          v-if="
            $store.state.step < 0 &&
            (!$store.state.usr.email || !$store.state.usr.logueado)
          "
        >
          {{ $t("common.complete_email") }}
          <step-email></step-email>
        </template>
        <template v-else>
          <template v-if="$store.state.usr.email">
            <h2>
              {{ $t("access.bienvenido") }} {{ $store.state.usr.name }} -
              {{ $store.state.usr.email }}
            </h2>
          </template>
          <div>
            <vs-button
              v-if="parseInt(this.$store.state.step) == -1"
              :active="true"
              @click="nextStep()"
              >{{ $t("common.next") }}
              <i class="material-icons">navigate_next</i>
            </vs-button>
          </div>
        </template>
        <vs-button
          warn
          gradient
          size="mini"
          v-if="$store.state.usr.email && $store.state.step == -1"
          @click="clearUsrData()"
        >
          {{ $t("common.im_other") }}
        </vs-button>
        <div v-if="$store.state.step >= 0" class="columns">
          <!-- Esto es del store 
          <pre>{{this.$store.state.regForm}}</pre> -->
          <div class="column is-8 is-offset-2">
            <horizontal-stepper
              :locale="this.$i18n.locale"
              :top-buttons="true"
              :steps="regSteps"
              @completed-step="completeStep"
              @clicking-back="backStep"
              @active-step="isStepActive"
              @stepper-finished="finishReg"
            >
            </horizontal-stepper>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="jumbotron jumbotron3" style="text-align: center">
      {{ $t("common.registration_closed") }}
      {{ this.$store.state.evento.FechaCierreInscripciones }}
    </div>
    <!-- PARA INTENTAR UN BLUR MIENTRAS REALIZA TAREAS DE BACKEND -->
    <div v-if="showBlur" class="blur-overlay"></div>
  </div>
</template>
<script>
//import schema from './data/schema.json'
//ESTO ES COPIADO DEL VIEJO PHP. VER CÓMO SE LO INCLUYE
//script src="/common/js/detecta-zona-horaria/jstz.min.js"
//$geoip_cod = geoip_country_code_by_name($_SERVER['REMOTE_ADDR']); Para obtener el país del cliente
import store from "@/store.js";
import HorizontalStepper from "vue-stepper";
import StepEmail from "@/components/StepEmail.vue";
import StepForm from "@/components/StepForm.vue";
import StepForm1 from "@/components/StepForm1.vue";
import StepForm2 from "@/components/StepForm2.vue";
import StepForm3 from "@/components/StepForm3.vue";
import StepFormN from "@/components/StepFormN.vue";
import StepOfertaDemanda from "@/components/StepOfertaDemanda.vue";

import "@/assets/css/HorizontalStepper.css";

export default {
  name: "MainRegForm",
  components: {
    HorizontalStepper,
    StepEmail,
    StepForm,
    StepForm1,
    StepForm2,
    StepForm3,
    StepFormN,
    StepOfertaDemanda,
  },
  data() {
    return {
      store,
      regSteps: [
        // {
        //     id: 0,
        //     icon: 'account_circle', // Name of icons that belong to material-icons library
        //     name: 'datosBásicos',
        //     title: 'Datos básicos',
        //     subtitle: 'de contacto',
        //     component: StepForm,
        //     completed: false
        // }
      ],
      showBlur: false,
    };
  },
  mounted() {
    if (
      this.$route.params.ide &&
      this.$route.params.ide != 0 &&
      this.$route.params.pli &&
      this.$route.params.pli != 0
    ) {
      this.RecuperarInfoEventoyPlan(
        this.$route.params.ide,
        this.$route.params.pli
      );
      this.clearUsrData();
    }
  },
  watch: {
    // para que cargue los campos con el lang correcto
    "$i18n.locale": function () {
      // Para actualizar el locale en el store (para fechas)
      //this.$store.state.interfaseLang = this.$i18n.locale
      // console.log(this.$i18n.locale)
      var i = 0;
      this.$store.state.evento.steps.forEach((s) => {
        // console.log(s)
        this.regSteps[i].title = this.stepTitle(s);
        this.regSteps[i].subtitle = this.stepSubTitle(s);
        i = i + 1;
      });
    },
  },
  methods: {
    nombreComponente(groupId) {
      if (parseInt(groupId) == 0) {
        return StepForm;
      }
      if (parseInt(groupId) == 1) {
        return StepForm1;
      }
      if (parseInt(groupId) == 2) {
        return StepForm2;
      }
      if (parseInt(groupId) == 3) {
        return StepForm3;
      }
      if (parseInt(groupId) >= 4 && parseInt(groupId) != 99) {
        return StepFormN;
      }
    },
    stepTitle(step) {
      var title;
      switch (this.$i18n.locale) {
        case "es":
          title = step.title_es;
          break;
        case "en":
          title = step.title_en;
          break;
        case "pt":
          title = step.title_pt;
          break;
      }
      return title;
    },
    stepSubTitle(step) {
      var subtitle;
      switch (this.$i18n.locale) {
        case "es":
          subtitle = step.subtitle_es;
          break;
        case "en":
          subtitle = step.subtitle_en;
          break;
        case "pt":
          subtitle = step.subtitle_pt;
          break;
      }
      return subtitle;
    },
    RecuperarInfoEventoyPlan(ide, pli) {
      const axios = require("axios"); // eslint-disable-line
      var url = this.$websiteGlobiz + "/api/json-reg-info-evento.php";
      var that = this;
      axios
        .post(url, {
          dev: !(process.env.NODE_ENV === "production"), // eslint-disable-line
          appid: 1,
          ide: ide,
          pli: pli,
        })
        .then(function (response) {
          that.$store.commit("resetEvent");
          that.$store.commit("updateEvent", response.data);
          if (response.data.error == 1) {
            that.$vs.notification({
              icon: "<i class='bx bx-error' ></i>",
              color: "danger",
              position: "top-center",
              progress: "auto",
              duration: 3000,
              border: "danger",
              title: "Error",
              text: that.$t(response.data.error_msg),
            });
          } else {
            //console.log('Actualiza store')
            that.$store.commit("updateEvent", response.data);
            var objStep;
            var i = 0;
            response.data.steps.forEach((step) => {
              const myComp = that.nombreComponente(i);
              objStep = {
                id: step.groupId,
                icon: step.icon,
                name: step.name,
                title: that.stepTitle(step),
                subtitle: that.stepSubTitle(step),
                component: myComp,
                completed: false,
              };
              i = i + 1;
              that.regSteps.push(objStep);
            });
            //Si corresponde, agrega el paso de oferta / demanda al final
            if (
              (parseInt(response.data.idTipoEvento) == 18 ||
                parseInt(response.data.idTipoEvento) == 19) &&
              parseInt(response.data.solicita_oferta_demanda) == 1
            ) {
              //console.log('Es evento rueda')
              objStep = {
                id: 99,
                icon: "shopping_bag",
                name: "ofertaDemanda",
                title: that.$t("common.tit_oferta_demanda"),
                subtitle: that.$t("common.lbl_oferta_demanda"),
                component: StepOfertaDemanda,
                completed: false,
              };
              that.regSteps.push(objStep);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // LOGIN - LOGOUT
    clearUsrData() {
      this.$store.commit("clearUsrData", "");
    },
    // access() {
    //   var datosLogin = {
    //     ide: this.$route.params.ide,
    //     username: this.email,
    //     passwd: this.pwd,
    //     firstLogin: false,
    //   };
    //   this.$store.dispatch("login", datosLogin);
    // },
    // STEPPER
    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.regSteps.forEach((step) => {
        if (step.name === payload.name) {
          step.completed = true;
          //this.$store.commit('nextStep')
          this.nextStep();
        }
      });
    },
    nextStep() {
      let n;
      if (parseInt(this.$store.state.step) < 0) {
        n = 0;
        if (this.$store.state.usr.email !== "") {
          //Verifica que el usuario no esté inscripto antes de dejar seguir
          var that = this;
          const axios = require("axios"); // eslint-disable-line
          var url = this.$websiteGlobiz + "/api/json-reg-existe-cuenta.php";
          axios
            .post(url, {
              dev: !(process.env.NODE_ENV === "production"), // eslint-disable-line
              appid: 1,
              ide: store.state.evento.ide,
              email: store.state.usr.email,
            })
            .then(function (response) {
              if (!response.data.id == 0) {
                if (response.data.idInsc == 0) {
                  //Si es usuario preexistente
                  store.commit("updateUsrData", response.data);
                  //Según la configuración del evento, solicita la clave o no
                  if (parseInt(store.state.evento.RequiereLogin) == 1) {
                    store.commit("askForPass", true);
                  } else {
                    //ver para definir el próximo paso
                    store.commit("nextStep", 0);
                  }
                } else {
                  store.commit("askForPass", false);
                  if (parseInt(store.state.evento.AdmiteReinsc) == 1) {
                    // Aunque el usuario ya está registrado en el evento,
                    // el mismo está configurado para admitir un nuevo registro con el mismo email
                    store.commit("updateUsrData", response.data);
                    store.commit("nextStep", 0);
                  } else {
                    //El usuario ya esta inscripto a este evento
                    that.$vs.notification({
                      icon: "<i class='bx bx-error' ></i>",
                      color: "warn",
                      position: "top-center",
                      progress: "auto",
                      duration: 3000,
                      border: "warn",
                      title: "Error !",
                      text: that.$t("error.cuenta_ya_inscripta"),
                    });
                  }
                }
              } else {
                //Si es nuevo usuario, sigue con los pasos pidiendo todos los datos
                store.commit("askForPass", false);
                //Busca si en localstorage hay algo guardado, si el email es el mismoa, no hace clear
                // if (!that.store.state.usr.email == email){
                //     store.commit('clearUsrData', email )
                // }
                //Si corresponde, pide clave que va a usar el usuario a crear
                if (parseInt(store.state.evento.RequiereLogin) == 1) {
                  that.askForPassNewUser = true;
                } else {
                  store.commit("nextStep", 0);
                }
              }
            });
        }
      } else {
        if (parseInt(this.$store.state.step) < this.regSteps.length - 1) {
          n = this.regSteps[parseInt(this.$store.state.step) + 1].id;
        }
        this.$store.commit("nextStep", n);
      }
    },
    backStep() {
      this.$store.commit("backStep");
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.regSteps.forEach((step) => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    // Executed when @stepper-finished event is triggered
    finishReg() {
      // Show blur effect
      this.showBlur = true;
      this.$store.commit("regFinished", {
        ide: this.$route.params.ide,
        pli: this.$route.params.pli,
        lang: this.$i18n.locale,
      });
    },
  },
};
</script>
<style>
/* CSS for blur overlay */
.blur-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5); /* Adjust opacity as needed */
  backdrop-filter: blur(5px); /* Adjust blur strength as needed */
  z-index: 9999; /* Ensure the overlay is above other content */
}
</style>
<!-- <style>
.contenedor {
  width: 1000px;
  margin: 0 auto;
  background: #fff;
  padding: 25px;
  border-radius: 25px;
  box-shadow: 0 1px 13px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.vs-button {
  /* background-color: #932852; */
  background-color: var(--iq-primary);
  color: #ffffff;
  /* border-color: #932852; */
  border-color: var(--iq-primary-dark);
  padding: 8px 20px;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.2;
  display: inline-block;
  position: relative;
  border-radius: 25px;
  text-transform: uppercase;
}
.vs-button:hover {
  background-color: var(--iq-primary-light);
}
.vs-button--default.vs-button--active {
  box-shadow: none;
  transform: none;
}
i {
  width: 26px;
}
@media screen and (max-width: 768px) {
  .contenedor {
    width: 25%;
    margin: 0 0;
  }
}
@media screen and (max-width: 479px) {
  .contenedor {
    width: 85%;
    margin: 0 0;
  }
}
</style> -->
